import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {SettingsService} from 'src/app/services/settings.service';
import {StorageService} from 'src/app/services/storage.service';
import {
  createInstitutionDesignationMutation,
  updateInstitutionDesignationMutation
} from 'src/app/store/entities/instution-settings/designation/designation.actions';
import {Designation} from 'src/app/store/entities/instution-settings/designation/designation.model';
import {Institution} from 'src/app/store/entities/system-settings/institution/institution.model';
import {AppState} from 'src/app/store/reducers';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {StoreItemEntity, StoreItemInput} from "../../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {
  CREATE_INSTUTION_DESIGNATION, UPDATE_INSTUTION_DESIGNATION
} from "../../../../store/entities/instution-settings/designation/designation.graphql";

@Component({
  selector: 'app-add-designation',
  templateUrl: './add-designation.component.html',
  styleUrls: ['./add-designation.component.scss']
})
export class AddDesignationComponent implements OnInit {

  title: string;
  designationForm: FormGroup;
  hide: boolean = true;
  selectedData: Designation;
  designation: Designation;
  institution: Institution



  constructor(
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<AddDesignationComponent>,
    private fb: FormBuilder,
    private storageService: StorageService,
  ) {
    this.selectedData = data
  }


  ngOnInit(): void {


    this.title = `${this.selectedData ? 'Update' : 'Add'} designation`

    this.institution = this.storageService.getItem('institution')
    this.designationForm = this.fb.group({
      designationShortForm: [null, Validators.required],
      designationName: [null, Validators.required],
      designationInstitution: [this.institution?.institutionUniqueId]
    });


    if (this.selectedData) {
      this.designationForm.patchValue({
        ...this.selectedData
      });
    }

  }


  closeModal(): void {
      this.dialogRef.close();
    }



submitForm(formValue: { designationShortForm: string,designationName:string,designationInstitution:string}) {
  let input: StoreItemInput = {
    entity: StoreItemEntity.institutionDesignation,
    input: {
      ...formValue,
      designationUniqueId: this.selectedData?.designationUniqueId
    },
    isInput: true,
    mutation: this.selectedData?.designationUniqueId ? UPDATE_INSTUTION_DESIGNATION: CREATE_INSTUTION_DESIGNATION
  }

  this.store.dispatch(StoreItemActions.createUpdateStoreItem(input))
  this.closeModal()

}








}
